import RequestReview from './RequestReview';

import React,{useState,useEffect} from 'react';
import {get,put} from '../utils/api';
import {useAuth} from '../context/AuthContext';

export default function AttendanceRequests(){
  const {user}=useAuth();
  const admin=user?.role==='super_admin';
  const [rows,setRows]=useState([]);
  const [error,setError]=useState('');
  const [message,setMessage]=useState('');
  const [busy,setBusy]=useState(false);
  const [loading,setLoading]=useState(true);
  const [file,setFile]=useState(null);
  const [fileKey,setFileKey]=useState(0);
  const blank={request_type:'absence',date:'',reason:'',is_medical:false,expected_arrival:''};
  const [form,setForm]=useState(blank);
  const load=async()=>{
    setLoading(true);
    try{const result=await get('/leave/attendance-requests');setRows(result.data||[]);}
    catch(e){setError(e.message);}
    finally{setLoading(false);}
  };
  useEffect(()=>{load();},[]);
  const submit=async e=>{
    e.preventDefault();setError('');setMessage('');setBusy(true);
    try{
      const body=new FormData();
      Object.entries(form).forEach(([key,value])=>body.append(key,String(value)));
      if(file&&form.is_medical)body.append('document',file);
      const res=await fetch('/api/leave/attendance-requests',{
        method:'POST',headers:{Authorization:'Bearer '+localStorage.getItem('bb_token')},body
      });
      const result=await res.json();
      if(!res.ok)throw Error(result.error||'Request failed');
      setForm(blank);setFile(null);setFileKey(k=>k+1);
      setMessage('Request submitted for Super Admin approval.');await load();
    }catch(e){setError(e.message);}finally{setBusy(false);}
  };
  const act=async(row,action)=>{
    const body={};
    if(action==='approve'&&row.request_type==='late'){
      const time=window.prompt('Approved arrival time (HH:MM)',row.expected_arrival);
      if(time===null)return;
      body.approved_arrival=time;
    }else if(action==='reject'){
      const reason=window.prompt('Reason for rejection');
      if(reason===null)return;
      body.rejection_reason=reason;
    }else if(!window.confirm(action==='approve'?'Approve this absence request?':'Cancel this request?'))return;
    if(action==='approve' && row.timing_status!=='notice_met'){
      const reason=window.prompt('This request did not establish 48-hour notice. Explain why you are approving it (at least 10 characters).');
      if(reason===null)return;
      body.approval_reason=reason;
    }
    setBusy(true);setError('');
    try{await put('/leave/attendance-requests/'+row.id+'/'+action,body);await load();}
    catch(e){setError(e.message);}finally{setBusy(false);}
  };
  const document=async row=>{
    setError('');
    const preview=window.open('','_blank');
    if(preview)preview.opener=null;
    try{
      const res=await fetch('/api/leave/attendance-requests/'+row.id+'/document',{
        headers:{Authorization:'Bearer '+localStorage.getItem('bb_token')}
      });
      if(!res.ok)throw Error('Certificate could not be opened.');
      const url=URL.createObjectURL(await res.blob());
      if(preview)preview.location.replace(url);
      else{URL.revokeObjectURL(url);throw Error('Allow pop-ups to view the certificate.');}
      setTimeout(()=>URL.revokeObjectURL(url),60000);
    }catch(e){if(preview)preview.close();setError(e.message);}
  };
  return <section>
    <h3>Absence and late-arrival requests</h3>
    <p>Submit at least 48 hours before your scheduled work start. Short-notice requests can still be submitted for Super Admin discretion. Approval is required to avoid the relevant attendance penalty. Late approval covers only the approved arrival time. Other attendance rules still apply. Medical absence requires a certificate.</p>
    {error&&<p role="alert" style={{color:'#8F2E24'}}>{error}</p>}
    {message&&<p role="status" style={{color:'#556B2F'}}>{message}</p>}
    <form onSubmit={submit} style={{background:'#F2EFE7',padding:16,borderRadius:8}}>
      <label className="form-group">Request type
        <select className="form-control" value={form.request_type} onChange={e=>{
          setForm({...form,request_type:e.target.value,is_medical:false});setFile(null);setFileKey(k=>k+1);
        }}><option value="absence">Absence</option><option value="late">Coming late</option></select>
      </label>
      <label className="form-group">Work date
        <input required type="date" className="form-control" value={form.date}
          onChange={e=>setForm({...form,date:e.target.value})}/>
      </label>
      {form.request_type==='late'&&<label className="form-group">Expected arrival time (Nigeria)
        <input required type="time" className="form-control" value={form.expected_arrival}
          onChange={e=>setForm({...form,expected_arrival:e.target.value})}/>
      </label>}
      <label className="form-group">Reason
        <textarea required minLength={5} className="form-control" value={form.reason}
          onChange={e=>setForm({...form,reason:e.target.value})}/>
      </label>
      {form.request_type==='absence'&&<label style={{display:'block',marginBottom:12}}>
        <input type="checkbox" checked={form.is_medical}
          onChange={e=>setForm({...form,is_medical:e.target.checked})}/> Medical absence
      </label>}
      {form.is_medical&&<label className="form-group">Medical certificate
        <input key={fileKey} required type="file" accept=".pdf,.png,.jpg,.jpeg"
          className="form-control" onChange={e=>setFile(e.target.files[0]||null)}/>
      </label>}
      <button className="btn btn-primary" disabled={busy||loading}>{busy?'Saving...':'Submit request'}</button>
    </form>
    <div style={{marginTop:20,display:'flex',justifyContent:'space-between'}}>
      <h3>{admin?'Staff attendance requests':'My attendance requests'}</h3>
      <button className="btn btn-outline btn-sm" disabled={busy||loading} onClick={load}>Refresh</button>
    </div>
    {loading?<p>Loading requests...</p>:rows.length===0?<p>No requests recorded.</p>:rows.map(row=>
      <article key={row.id} style={{border:'1px solid #ddd',padding:14,borderRadius:8,marginBottom:10}}>
        <strong>{row.staff_name} · {row.date} · {row.request_type==='late'?'Coming late':'Absence'}</strong>
        <p>Status: <strong>{row.status}</strong>{row.expected_arrival?' · Requested arrival '+row.expected_arrival:''}
          {row.approved_arrival?' · Approved arrival '+row.approved_arrival:''}</p>
        <div style={{padding:10,borderRadius:6,background:row.timing_status==='notice_met'?'#E8F5EB':'#FFF3DC'}}>
          <strong>{({notice_met:'48-hour notice met',short_notice:'Short notice',after_start:'Submitted after scheduled start',unavailable:'Timing unavailable'})[row.timing_status]||'Timing unavailable'}</strong>
          <p>Submitted: {new Date(row.created_at).toLocaleString('en-GB',{timeZone:'Africa/Lagos'})} (Nigeria)</p>
          {row.scheduled_start_at&&<p>Scheduled start: {new Date(row.scheduled_start_at).toLocaleString('en-GB',{timeZone:'Africa/Lagos'})} (Nigeria)</p>}
          {row.notice_hours!=null&&<p>{row.notice_hours<0?'Submitted after start by: ':'Notice given: '}{Math.floor(Math.abs(row.notice_hours))} hours {Math.floor((Math.abs(row.notice_hours)%1)*60)} minutes</p>}
          {!row.scheduled_start_at&&<p>This older request has no recorded schedule snapshot.</p>}
        </div>
        <p>{row.reason}</p>
        {row.approval_reason&&<p>Approval exception reason: {row.approval_reason}</p>}
        {row.rejection_reason&&<p>Rejection reason: {row.rejection_reason}</p>}
        {row.approved_by_name&&<p>Approved by {row.approved_by_name}</p>}
        {row.document_filename&&<button className="btn btn-outline btn-sm" onClick={()=>document(row)}>View certificate</button>}
        <RequestReview kind="attendance" id={row.id} onRefresh={load}/>
      </article>)}
  </section>;
}
